export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/qjPK3HjFTQ7JGf9W7R8T3C/PAGINA_3.png',
    alt: 'Sample page Fire Needs Four Things; Remove One and It Stops, explaining the fire triangle and the fire tetrahedron',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8RdXVfpZBb7pdCqNur5Gcj/PAGINA_7.png',
    alt: 'Sample page Every Room Fire Follows the Same Five Stages, charting incipient, growth, flashover, fully developed and decay stages',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3YcioodyMQrRq2QDPEWvdF/PAGINA_13.png',
    alt: 'Sample page There Are Only Four Ways to Put Out a Fire, covering cooling, smothering, fuel removal and chemical flame inhibition',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bSFDjNSfDJsZECNi5ckBLF/PAGINA_18.png',
    alt: 'Sample page Fire Protection Is a Chain of Six Links, showing prevention, detection, notification, suppression, compartmentation and emergency response',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/866SdZNueEWGHQr72yKiLt/PAGINA_50.png',
    alt: 'Sample page field checklist covering the fire, the space, the people, the systems, key numbers and five universal questions',
  },
];
